import { Component, OnInit, Input } from "@angular/core";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsService } from "ngx-permissions";
import { DomainConfigComponent } from "@app/domain-config.component";
import { MY_COMPANIES_MENU_PERMISSIONS } from "../my-companies/my-companies.permissions";

@Component({
    selector: "app-admin-tabs",
    templateUrl: "./admin-tabs.component.html",
    styleUrls: ["./admin-tabs.component.scss"],
    standalone: false
})
export class AdminTabsComponent implements OnInit {
  @Input() selecto: number;
  whatsappEnabled = false;
  legalStudyEnabled = false;
  /** Permiso propio de Mis Compañías (no reutilizar flows.menu.perfil.clients). */
  readonly myCompaniesPermissions = [...MY_COMPANIES_MENU_PERMISSIONS];

  constructor(private modalService: NgbModal,
    private permissionsService: NgxPermissionsService,
    private domainConfig: DomainConfigComponent
    ) {}

  ngOnInit() {
    // El tab WhatsApp solo se muestra si el canal está habilitado para el tenant
    // (trackvision.whatsappEnabled, que controla Inprovider). La config del dominio ya está
    // cargada tras el login; por seguridad forzamos load() y leemos el flag.
    Promise.resolve(this.domainConfig.load && this.domainConfig.load())
      .catch(() => {})
      .finally(() => {
        try {
          this.whatsappEnabled = this.domainConfig.isWhatsappEnabled();
          this.legalStudyEnabled = this.domainConfig.isLegalStudyAssignmentEnabled();
        } catch {
          this.whatsappEnabled = false;
          this.legalStudyEnabled = false;
        }
      });
  }

  modalOpenUserManage(content) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }
}
